import { SeatmapStoreModel } from '@common/interfaces/servicing-seatmap/seatmap-store-model';
/**
 * CheckinSeatmap model details
 */
export interface ServicingSeatmapBackupStateDetails {}

/**
 * ServicingSeatmapBackup store state
 */
export interface ServicingSeatmapBackupState extends ServicingSeatmapBackupStateDetails {
  model: SeatmapStoreModel | null;
}

/**
 * Name of the ServicingSeatmapBackup Store
 */
export const SERVICING_SEATMAP_BACKUP_STORE_NAME = 'servicingSeatmapBackup';

/**
 * ServicingSeatmapBackup Store Interface
 */
export interface ServicingSeatmapBackupStore {
  /** ServicingSeatmap state */
  [SERVICING_SEATMAP_BACKUP_STORE_NAME]: ServicingSeatmapBackupState;
}